export var E_CORE_ACTION_TYPES;
(function (E_CORE_ACTION_TYPES) {
    E_CORE_ACTION_TYPES["RESET_CONF"] = "RESET_CONF";
    E_CORE_ACTION_TYPES["UPDATE_URL_CONF_REQUESTED"] = "UPDATE_URL_CONF_REQUESTED";
    E_CORE_ACTION_TYPES["UPDATE_URL_CONF_SUCCEEDED"] = "UPDATE_URL_CONF_SUCCEEDED";
    E_CORE_ACTION_TYPES["FETCH_CONF_REQUESTED"] = "FETCH_CONF_REQUESTED";
    E_CORE_ACTION_TYPES["FETCH_CONF_SUCCEEDED"] = "FETCH_CONF_SUCCEEDED";
    E_CORE_ACTION_TYPES["ADD_NOTIFICATION_REQUESTED"] = "ADD_NOTIFICATION_REQUESTED";
    E_CORE_ACTION_TYPES["ADD_NOTIFICATION_SUCCEEDED"] = "ADD_NOTIFICATION_SUCCEEDED";
    E_CORE_ACTION_TYPES["REMOVE_NOTIFICATION_REQUESTED"] = "REMOVE_NOTIFICATION_REQUESTED";
    E_CORE_ACTION_TYPES["REMOVE_NOTIFICATION_SUCCEEDED"] = "REMOVE_NOTIFICATION_SUCCEEDED";
    E_CORE_ACTION_TYPES["UPDATE_REALM_REQUESTED"] = "UPDATE_REALM_REQUESTED";
    E_CORE_ACTION_TYPES["UPDATE_REALM_SUCCEEDED"] = "UPDATE_REALM_SUCCEEDED";
    E_CORE_ACTION_TYPES["ADD_FILE_URLS_REQUESTED"] = "ADD_FILE_URLS_REQUESTED";
    E_CORE_ACTION_TYPES["ADD_FILE_URLS_SUCCEEDED"] = "ADD_FILE_URLS_SUCCEEDED";
    E_CORE_ACTION_TYPES["ADD_FILE_URLS_CANCELLED"] = "ADD_FILE_URLS_CANCELLED";
    E_CORE_ACTION_TYPES["UPDATE_LOCALE"] = "UPDATE_LOCALE";
    E_CORE_ACTION_TYPES["PING_API_REQUESTED"] = "PING_API_REQUESTED";
    E_CORE_ACTION_TYPES["PING_API_SUCCEEDED"] = "PING_API_SUCCEEDED";
    E_CORE_ACTION_TYPES["UPDATE_FILE_URL_SOURCE"] = "UPDATE_FILE_URL_SOURCE";
})(E_CORE_ACTION_TYPES || (E_CORE_ACTION_TYPES = {}));
